
import Component from '../../../assets/scripts/modules/component'
import cookiesSimple from '../../../vendor/scripts/fabrique/modules/cookies-simple'
import fireCustomEvent from '../../../vendor/scripts/fabrique/modules/fire-custom-event'

class FooterComponent extends Component {
  init () {
    this.animationsToggle = this.element.querySelector('input[name="disable-animations"]')

    if (this.animationsToggle) {
      this.initAnimationsToggle()
    }

    if (!cookiesSimple.get('disable-animations') && window.matchMedia('(prefers-reduced-motion)').matches) {
      this.animationsToggle.checked = true
    }
  }

  initAnimationsToggle () {
    const disabled = cookiesSimple.get('disable-animations') === 'true'

    document.documentElement.classList.toggle('disable-animations', disabled)
    this.animationsToggle.checked = disabled

    this.animationsToggle.addEventListener('change', () => {
      cookiesSimple.set('disable-animations', this.animationsToggle.checked)
      document.documentElement.classList.toggle('disable-animations', this.animationsToggle.checked)
    })
  }
}

window.addEventListener('init-load', () => {
  for (const element of document.querySelectorAll('.footer')) {
    element.instance = element.instance || new FooterComponent(element)
  }
})
